import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import FFEDashboard from './FFEDashboard';
import ChecklistDashboard from './ChecklistDashboard';

/* Preview-only wrapper: renders the real sheet (header + old nav hidden) and, when
   theme=light, applies a light skin over the sheet's dark Tailwind classes. Used by
   the /layout-options design preview so the actual sheet can be shown in light or dark. */
const LIGHT_CSS = `
.est-light [class*="from-black"], .est-light .bg-gradient-to-b { background: linear-gradient(180deg,#EFECE4 0%,#FBF9F4 100%) !important; }
.est-light .bg-black { background:#FFFFFF !important; }
.est-light .bg-gray-900 { background:#F4F1EA !important; }
.est-light .bg-gray-800 { background:#ECE8DF !important; }
.est-light .bg-gray-700 { background:#E2DDD2 !important; }
.est-light [style*="rgba(0, 0, 0, 0.95)"] { background: linear-gradient(135deg,#FFFFFF 0%,#F6F3EC 50%,#FFFFFF 100%) !important; }
.est-light [style*="rgb(15, 23, 42)"], .est-light [style*="rgb(30, 41, 59)"] { background:#FFFFFF !important; }
.est-light .text-white, .est-light .text-gray-100, .est-light .text-gray-200, .est-light .text-gray-300 { color:#1A1611 !important; }
.est-light .text-gray-400 { color:#463F33 !important; }
.est-light .text-gray-500 { color:#5F584C !important; }
.est-light input, .est-light select, .est-light textarea { color:#241E15 !important; }
`;

const EmbedSheet = ({ type, isOffline }) => {
  const { projectId } = useParams();
  const [sp] = useSearchParams();
  const light = sp.get('theme') === 'light';
  const Comp = type === 'checklist' ? ChecklistDashboard : FFEDashboard;
  return (
    <div className={light ? 'est-light' : ''}>
      {light && <style>{LIGHT_CSS}</style>}
      <Comp isOffline={isOffline} hideNavigation hideHeader projectId={projectId} />
    </div>
  );
};

export default EmbedSheet;
